import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { hideSnackBar } from 'actions/globalActions';

import './style.css';

class SnackBar extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.show === false && this.props.show === true) {
      setTimeout(() => this.props.hideSnackBar(), 3000);
    }
  }

  render() {
    const { show } = this.props;

    return (
      <div
        className={classnames('snack-bar d-flex align-items-center justify-content-center', {
          'snack-bar--show': show
        })}
      >
        <p className="m-0">Changes confirmed!</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    show: state.globalStatus.snackBar.show
  };
}

export default connect(mapStateToProps, {
  hideSnackBar
})(SnackBar);



// WEBPACK FOOTER //
// ./src/components/SnackBar/index.js